<template>
  <div class="app-view home" ref="view-home">
    <video src="@/assets/video/video_main_cut.mp4" autoplay muted loop></video>

    <div class="app-view-content">
      <span class="project-name">
        VIDOLIA RP
      </span>

      <span class="project-desc">Ролевой сервер, который предоставляет возможность погрузиться <br>в различные роли во вселенной <a>«Клинок, рассекающий демонов»</a></span>
    </div>
  </div>
  <NavBar/>

  <div class="app-view who-the-fuck content-ebatb fix-sticky" ref="view-who">
    <video src="@/assets/video/video_features_cut.mp4" autoplay muted loop></video>

    <div class="app-view-content animated">
      <div class="content-features">
        <div class="features-carousel">
          <div class="features-carousel-card">
            <div class="carousel-card-top">
              <img src="@/assets/KGT0zSh2Hs%201.png">
            </div>

            <div class="carousel-card-content">
              <span class="carousel-card-caption">
                Ранговая система для каждой фракции
              </span>

              <span class="carousel-card-desc">
                У каждой фракции есть своя ранговая система, продвижение по которой происходит за счёт различных активностей, инициируемых как игроками, так и персоналом проекта, а также и вами.
              </span>
            </div>
          </div>

          <div class="features-carousel-card">
            <div class="carousel-card-top">
              <img src="@/assets/xeuXsmFazv%201.png">
            </div>

            <div class="carousel-card-content">
              <span class="carousel-card-caption">
                Обширная локация
              </span>

              <span class="carousel-card-desc">
               На проекте имеется достаточно большая карта, на которой можно встретить множество городов, лесов и мелких строений, а также множество маленьких незаметных локаций, каждая из которых обладает своим шармом и атмосферой.
              </span>
            </div>
          </div>

          <div class="features-carousel-card">
            <div class="carousel-card-top">
              <img src="@/assets/KGT0zSh2Hs%201.png">
            </div>

            <div class="carousel-card-content">
              <span class="carousel-card-caption">
                Ранговая система для каждой фракции
              </span>

              <span class="carousel-card-desc">
                У каждой фракции есть своя ранговая система, продвижение по которой происходит за счёт различных активностей, инициируемых как игроками, так и персоналом проекта, а также и вами.
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="wtf-container">
        <span class="wtf-title">
          ЧЕМ МОЖНО ЗАНЯТЬСЯ?
        </span>

        <p class="wtf-exactly">
          Здесь вы можете пойти по пути главного героя Танджиро и через усердные тренировки стать истребителем демонов, или же пройти путь от дикого и слабого демона до представителя Дюжины Лун
        </p>
      </div>
    </div>
  </div>

  <div class="app-view join-us" ref="view-join">
    <video src="@/assets/video/video_join_cut.mp4" autoplay muted loop></video>
    <div class="app-view-content join-us-container">
        <div class="join-us-hero">
          <div class="join-us-hero-content">
            <span class="join-us-title">
              НАЧНИТЕ ИГРАТЬ С НАМИ
              <span>ТЕНКСТ КАКОЙ_ТО</span>
            </span>
            <LeButton class="is-white-hl">
              <template #icon>
                <i class="fas fa-right-to-bracket"></i>
              </template>

              Подключиться к серверу
            </LeButton>
          </div>
        </div>
    </div>
  </div>
</template>
<style lang="sass">

@keyframes fade-appear
  from
    backdrop-filter: blur(0)

  to
    backdrop-filter: blur(25px)

.app-view
  display: flex
  flex-direction: column
  position: relative

  video
    width: 100%
    height: 100%
    object-fit: cover
    position: absolute

  &-content
    min-height: 100vh
    min-width: 100vw
    z-index: 1
    display: flex
    flex-direction: column

    &.animated
      background: rgba(#000, 0.5)
      animation: fade-appear 5s forwards

  &.home
    background: url('@/assets/4TyjZHdm47 1.png') center center no-repeat
    background-size: cover

    .project-name
      color: #FFF
      font-family: "Halvar Breit XBd", sans-serif
      font-size: 76px
      font-style: normal
      font-weight: 800
      line-height: 130%
      letter-spacing: -0.76px
      text-transform: uppercase
      margin-top: 20px

    .project-desc
      color: rgba(255, 255, 255, 0.50)
      text-align: center
      font-family: Inter, sans-serif
      font-size: 16px
      font-style: normal
      font-weight: 500
      line-height: 130%
      letter-spacing: -0.64px
      //margin-top: 0px

      a
        color: white
        text-decoration: none


    &.who-the-fuck
      background: url('@/assets/RyfKuZ0QA9 1.png') center center no-repeat
      background-size: cover
      color: #fff

  &.join-us
    height: 100vh
    overflow: hidden
    display: flex

    .join-us-container
      display: flex
      flex-direction: column

    .join-us-title
      font-family: "Halvar Breit XBd", sans-serif
      text-transform: uppercase
      font-size: 48px

    .join-us-hero
      margin: auto
      padding: 30px
      background: radial-gradient(rgba(0, 0, 0, 0.5) 0%, transparent 80%)
      backdrop-filter: blur(1px)

      .join-us-title
        display: block
        color: white

        span
          display: block
          font-size: 24px
          line-height: 2

      .le-button
        margin-top: 10px
        display: inline-flex



  .wtf-container
    text-align: left
    display: flex
    flex-direction: column
    max-width: 600px
    padding: 36px 0 56px 36px
    margin: auto 0 0 0
    color: white

  .wtf-title
    font-family: "Halvar Breit XBd", serif
    text-transform: uppercase
    font-size: 48px

  .wtf-exactly
    font-family: Inter, serif
    font-size: 16px
    font-style: normal
    font-weight: 500
    line-height: 130% /* 20.8px */
    letter-spacing: -0.32px

  .content-features
    margin-top: 133px
    overflow-x: auto

  .features-carousel
    display: inline-flex
    flex-direction: row

    .features-carousel-card
      //background: #FFFFFF
      width: 590px
      box-shadow: 0 1px 2px rgba(20, 21, 26, 0.05)
      border-radius: 8px
      margin: 0 20px

      .carousel-card-top
        width: 100%
        border-radius: 15px
        overflow: hidden

      .carousel-card-content
        display: inline-flex
        font-family: Inter, serif
        text-align: left
        color: white
        margin-top: 20px


        .carousel-card-caption
          font-size: 20px
          min-width: 35%

        .carousel-card-desc
          font-size: 14px
          float: right
          margin-left: 30px
          padding: 0 20px
          opacity: 0.8

</style>

<script>
// @ is an alias to /src
import NavBar from "@/components/NavBar.vue";
import LeButton from "@/components/LeButton.vue";


export default {
  name: 'HomeView',
  components: {
    LeButton,
    NavBar
  },
  mounted() {
    document.addEventListener("wheel", this.onScroll)
  },
  methods: {
    onScroll(e) {
      e.preventDefault();
      if (this.scrollAnim) return;

      let views = [
          this.$refs["view-home"],
          this.$refs["view-who"],
          this.$refs["view-join"]
      ];
      let scroll = document.documentElement.scrollTop;
      let scrollDelta = e.deltaY;
      let currentView, currentViewId

      for (let i = 0; i < views.length; i++) {
        if (scroll >= views[i].offsetTop) {
          currentView = views[i];
          currentViewId = i;
        }
      }

      if (Math.abs(scrollDelta) < 0.1) return


      let scrollDir = scrollDelta > 0 && 1||-1
      currentViewId += scrollDir

      if (currentViewId < 0) currentViewId = 0
      if (currentViewId >= views.length) currentViewId = views.length - 1
      currentView = views[currentViewId]

      document.documentElement.scrollTo({
        top: currentView.offsetTop,

        behavior: "smooth",
      })

      // this.scrollAnim = setInterval(() => {
      //
      //
      //   if (scroll >= views[views.length - 1].offsetTop) {
      //     clearInterval(this.scrollAnim)
      //     console.log("done")
      //     this.scrollAnim = null
      //   }
      //
      //   //console.log(scroll, views[views.length - 1].offsetTop)
      // }, 10)
    }
  }
}
</script>
